import { z } from 'zod';

export const getAddressSchema = z.object({
    building_name: z.string(),
    building_number: z.string(),
    country: z.string(),
    county: z.string(),
    district: z.string(),
    formatted_address: z.array(z.string()),
    latitude: z.number(),
    longitude: z.number(),
    line_1: z.string(),
    line_2: z.string(),
    line_3: z.string(),
    line_4: z.string(),
    locality: z.string(),
    postcode: z.string(),
    residential: z.boolean(),
    sub_building_name: z.string(),
    sub_building_number: z.string(),
    thoroughfare: z.string(),
    town_or_city: z.string(),
});
